import * as styles from "./DatePickerArrow.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Popover as BasePopover } from "@base-ui/react/popover";

import { useDatePickerContext } from "./DatePicker.context";
import type { DatePickerArrowProps } from "./DatePicker.types";

export function DatePickerArrow({
  className,
  style,
  ...props
}: DatePickerArrowProps): JSX.Element {
  const { size } = useDatePickerContext();

  return (
    <BasePopover.Arrow
      data-slot="date-picker-arrow"
      className={clsx(styles.arrow({ size }), className)}
      style={{ left: "50%", transform: "translateX(-50%)", ...style }}
      {...props}
    />
  );
}
